import { useNavigate } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { Button } from '@/cn/ui/button'
import { popup } from '@/popup_handler'
const Accounts = () => {
  const navigate = useNavigate()

  return (
    <div className="p-6 font-sans">
      <h1 className="text-2xl font-semibold mb-6">Accounts</h1>

      <div className="flex flex-col gap-4 ">
        <Button className="h-14 flex" onClick={() => navigate('/dashboard/balance')} variant="link">
          <div className="w-full">Check Balance</div>
          <ArrowRight />
        </Button>
        <Button className="h-14 flex" onClick={() => popup.open('coming_soon')} variant="link">
          <div className="w-full">Settle Money</div>
          <ArrowRight />
        </Button>
        <Button className="h-14 flex" onClick={() => navigate('/dashboard/send-anyone')} variant="link">
          <div className="w-full"> Send Money</div>
          <ArrowRight />
        </Button>
      </div>
    </div>
  )
}

export default Accounts
